import React from "react";
import { Box } from "@singlestore/fusion/components/layout";
import { useProductVersion } from "contexts/ProductVersionContext";

import { NavVersionSelector } from "components/layout/DocumentNavMenu/NavVersionSelector";
import { NavigationTree } from "components/NavigationTree/NavigationTree";

import { track } from "utils/segment";

import "./DocumentNavMenu.scss";

type DocumentNavMenuProps = {
    beforeNavigate?: (path: string) => void;
};

export function DocumentNavMenu({
    beforeNavigate = () => {},
}: DocumentNavMenuProps) {
    const { productVersionNode } = useProductVersion();

    if (!productVersionNode) {
        return null;
    }

    const handleBeforeNavigate = (path: string, name: string) => {
        track("UI Element Clicked", {
            elementName: name,
            elementType: "Sidebar Link",
            destination: path,
        });
        beforeNavigate?.(path);
    };

    return (
        <div className="document-navigation">
            <NavVersionSelector />

            <Box className="navigation-tree">
                <NavigationTree
                    productVersionNode={productVersionNode}
                    beforeNavigate={handleBeforeNavigate}
                />
            </Box>
        </div>
    );
}
